import type { FC } from 'react'
import { RadioGroup } from '@headlessui/react'
import { useRecipientSelect, useRecipientSelectOpsDispatch } from './RecipientSelectProvider'
import RecipientSection from './RecipientSection'

const RecipientRadioGroup: FC = () => {
  const { selectedRadioCosId } = useRecipientSelect()
  const dispatch = useRecipientSelectOpsDispatch()

  return (
    <RadioGroup
      className="flex flex-col mb-4 space-y-4 grow"
      value={selectedRadioCosId}
      onChange={(option) => dispatch({ type: 'select-radio-recipient', cosId: option })}
    >
      <RadioGroup.Label className="sr-only">
        Find your account or select person to gift
      </RadioGroup.Label>
      <RecipientSection />
    </RadioGroup>
  )
}

export default RecipientRadioGroup
